/* eslint-disable consistent-return */
import { loaderService } from 'src/services/loaderService';
import { apileads } from '../enviroment/apileads';

// ----- Distribucion global -----
const getDistribucionGlobal = async () => {
  try {
    const response = await apileads.get('/v1/distribucion-global');
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error get distribucion global', error);
  }
};

const putDistribucionGlobal = async (params) => {
  loaderService.show();
  const body = {
    categoria: params.categoria,
    porcentaje_ia: Number(params.porcentaje_ia),
  };
  try {
    const response = await apileads.put('/v1/distribucion-global', body);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error al actualizar distribucion global', error);
  } finally {
    loaderService.hide();
  }
};

// ----- Distribucion override -----
const getDistribucionOverride = async () => {
  try {
    const response = await apileads.get('/v1/distribucion-override');
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error get distribucion override', error);
  }
};

const postDistribucionOverride = async (params) => {
  loaderService.show();
  const body = {
    departamento: params.departamento,
    id_vehiculo: parseInt(params.id_vehiculo, 10),
    vehiculo: params.vehiculo,
    porcentaje_ia: Number(params.porcentaje_ia),
    estado: parseInt(params.estado, 10),
  };
  try {
    const response = await apileads.post('/v1/distribucion-override', body);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error al crear override', error);
  } finally {
    loaderService.hide();
  }
};

const putDistribucionOverride = async (params) => {
  loaderService.show();
  const body = {
    id: parseInt(params.id, 10),
    departamento: params.departamento,
    id_vehiculo: parseInt(params.id_vehiculo, 10),
    vehiculo: params.vehiculo,
    porcentaje_ia: Number(params.porcentaje_ia),
    estado: parseInt(params.estado, 10),
  };
  try {
    const response = await apileads.put('/v1/distribucion-override', body);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error al actualizar override', error);
  } finally {
    loaderService.hide();
  }
};

const deleteDistribucionOverride = async (id) => {
  try {
    const response = await apileads.delete(`/v1/distribucion-override?id=${id}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error al eliminar override', error);
  }
};

// ----- Vehiculos activos (estado = 1) para el dropdown -----
const getVehiculosActivos = async () => {
  try {
    const response = await apileads.get('/v1/vehiculos-activos');
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error get vehiculos activos', error);
  }
};

export {
  getDistribucionGlobal,
  putDistribucionGlobal,
  getDistribucionOverride,
  postDistribucionOverride,
  putDistribucionOverride,
  deleteDistribucionOverride,
  getVehiculosActivos,
};
